export enum DamageRiskStatus {
    Closed = 'Closed',
    Active = 'Active',
    Removed = 'Removed'
}
